export default class SiteHeader {
    constructor({ header, btn, onOpen, onClose }) {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;

        this._open = false;
        this._btn?.addEventListener("click", this.onBtnClick.bind(this));
    }

    onBtnClick(e) {
        this._open
            ? this.closeMenu()
            : this.openMenu();
    }

    closeMenu() {
        this._header.classList.remove("is-open");       
        this._open = false;
        this._onClose?.();
    }

    openMenu() {
        if (!this._header?.classList.contains("is-open"))
            this._header.classList.add("is-open");
        this._open = true;
        this._onOpen?.();
    }
}